























































































































































import { ColDef, ColumnApi, GridApi } from 'ag-grid-community';
import { AgGridVue } from 'ag-grid-vue';
import axios from 'axios';
import Vue from 'vue';

import Building from '../../components/Building.vue';
import Dropdown from '../../components/Dropdown.vue';
import Loader from '../../components/Loader.vue';
import MenuDropdown from '../../components/MenuDropdown.vue';
import Utils from '../../Utils';
import { logout } from '../../utils/authUtils';
import LoadingHelper from '../../utils/loadingHelper';
import DateCellRenderer from '../../views/Admin/renderers/DateCellRenderer.vue';

import '../../../node_modules/ag-grid-community/dist/styles/ag-grid.css';
import '../../../node_modules/ag-grid-community/dist/styles/ag-theme-material.css';
import DownloadApplicationRenderer from '../../views/Admin/renderers/DownloadApplicationRenderer.vue';
import EmailCellRenderer from '../../views/Admin/renderers/EmailCellRenderer.vue';
import PartBCellRenderer from '../../views/Admin/renderers/PartBCellRenderer.vue';

import { ApplicationSearchParams, ApplicationYear } from '../../models';

export default Vue.extend({
  components: {
    AgGridVue,
    Loader,
    DateCellRenderer,
    Dropdown,
    MenuDropdown,
    Building,
  },
  data() {
    return {
      columnDefs: null as ColDef[] | null,
      gridApi: null as GridApi | null,
      columnApi: null as ColumnApi | null,
      rowData: null as object[] | null,
      searchText: '' as string,
      exportLoading: {
        csv: false,
        pdf: false,
        completedPdf: false,
        regionBest: false,
      },
      // TODO: need to type these
      selectedRows: [] as any[],
      selectedYear: 'ALL' as 'ALL' | number,
      years: undefined as ApplicationYear[] | undefined,
      fetchingData: true as boolean,
    };
  },
  methods: {
    onGridReady(params) {
      this.gridApi = params.api;
      this.columnApi = params.columnApi;
    },
    sort(event, param: 'region-score' | 'gpa-partb' | 'submission-date') {
      if (this.gridApi) {
        (this.$refs.sortDropdown as any).togglePopover();
        if (param === 'region-score') {
          this.gridApi.setSortModel([
            { colId: '_region', sort: 'desc' },
            { colId: 'score', sort: 'desc' },
          ]);
        } else if (param === 'gpa-partb') {
          this.gridApi.setSortModel([
            { colId: 'partBUri', sort: 'desc' },
            { colId: 'gpa', sort: 'desc' },
          ]);
        } else if (param === 'submission-date') {
          this.gridApi.setSortModel([
            { colId: 'applicationDateCreated', sort: 'desc' },
          ]);
        }
      }
    },
    async downloadApplications(
      type: string,
      selected: boolean = false,
      options: {
        sorters?: {
          field: string;
          direction?: string;
        }[];
      } = {}
    ) {
      (this.$refs.exportDropdown as any).togglePopover();
      if (window['appInsights']) {
        window['appInsights'].trackEvent(
          'Exporting Applications as ' + type,
          {}
        );
      }

      const payload: {
        type?: string;
        filter?: string;
        appIds?: string[];
        year?: number;
        options: {
          sorters?: {
            field: string;
            direction?: string;
          }[];
        };
      } = {
        type: undefined,
        filter: undefined,
        appIds: undefined,
        year: this.selectedYear === 'ALL' ? undefined : this.selectedYear,
        options,
      };

      if (selected) {
        if (!this.selectedRows.length) {
          Vue.toasted.error('No applications selected', {
            duration: 5000,
          });
          return;
        }

        const ids = this.selectedRows.map(row => row.applicationId);
        payload.appIds = ids;
      }

      this.exportLoading[type] = true;

      // Sorry for the "magic strings" :(
      if (type === 'csv') {
        payload.type = 'csv';
      } else if (type === 'pdf') {
        payload.type = 'pdf';
      } else if (type === 'completedPdf') {
        payload.type = 'pdf';
        payload.filter = 'completed';
      } else if (type === 'regionBest') {
        payload.type = 'pdf';
        payload.filter = 'regionBest';
      }

      const loader = new LoadingHelper(1000);

      Vue.toasted.show(
        'Document creation may take a while. Your file will be downloaded upon completion.',
        { duration: 5000 }
      );

      loader.onComplete = async res => {
        if (res instanceof Error) {
          Utils.toastError('An error has occured');
          this.exportLoading[type] = false;
          return;
        }
        let encodedUrl;
        let filename;

        if (res.status === 204) {
          Vue.toasted.info('No records available for export.');
          this.exportLoading[type] = false;
          return;
        }

        if (res.data instanceof Blob) {
          encodedUrl = URL.createObjectURL(res.data);
          filename =
            res.headers['content-disposition']
              .split('"')[1]
              .replace(/"/g, '') || 'file';
        } else {
          let base64 = atob(res.data.fileContents);
          base64 = base64.replace(/#/g, '');
          encodedUrl = 'data:text/csv;charset=utf-8,sep=;\n' + base64;

          filename = res.data.fileDownloadName;
        }

        const link = document.createElement('a');
        link.setAttribute('href', encodedUrl);
        link.setAttribute('download', filename);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        this.exportLoading[type] = false;
      };

      loader.onError = err => {
        Utils.toastError('An error has occured');
        this.exportLoading[type] = false;
      };

      loader.start();

      try {
        const res = await axios.post(
          // @ts-ignore
          `${process.env.VUE_APP_API_URI}/api/admin/applications/export`,
          payload,
          {
            responseType: 'blob',
          }
        );
        loader.complete(res);
      } catch (err) {
        loader.complete(err);
      }
    },
    logout() {
      logout();
    },
    onFilterTextChange(e) {
      const searchText = e.target.value;
      if (this.gridApi) {
        this.gridApi.setQuickFilter(searchText);
      }
    },
    onSelectionChange(params) {
      if (this.gridApi) {
        this.selectedRows = this.gridApi.getSelectedRows();
      }
    },
    async updateGpa(params) {
      if (
        (!params.oldValue && !params.newValue && params.newValue !== 0) ||
        parseFloat(params.newValue) === params.oldValue
      ) {
        return;
      }
      const patchData = {
        gpa: params.newValue || 0,
      };

      axios
        .patch(
          // @ts-ignore
          `${process.env.VUE_APP_API_URI}/api/admin/applications/${params.data.applicationId}`,
          patchData
        )
        .then(res => {
          params.node.setData({
            ...params.data,
            gpa: res.data.gpa,
          });
        })
        .catch(e => {
          if (e.response && e.response.status && e.response.status === 400) {
            Vue.toasted.error(`"${params.newValue}" isn't a valid GPA.`);
          } else {
            Vue.toasted.error('An error occured. Please try again later.');
          }

          params.node.setData({
            ...params.data,
            gpa: params.oldValue,
          });
        });
    },
    filterYear(year: 'ALL' | number) {
      if (this.$refs.yearDropdown && (this.$refs.yearDropdown as any).isOpen) {
        (this.$refs.yearDropdown as any).togglePopover();
      }
      this.selectedYear = year;

      this.fetchingData = true;

      try {
        axios
          // @ts-ignore
          .post(`${process.env.VUE_APP_API_URI}/api/admin/applications`, {
            year: this.selectedYear === 'ALL' ? undefined : this.selectedYear,
          } as ApplicationSearchParams)
          .then(res => {
            if (res.status === 200) {
              this.rowData = res.data;
              this.fetchingData = false;
              if (this.gridApi) {
                this.gridApi.sizeColumnsToFit();
              }
            }
          });
      } catch (err) {
        Utils.toastError('Unable to fetch applications');
        this.fetchingData = false;
      }
    },
  },
  created() {
    axios
      // @ts-ignore
      .get(`${process.env.VUE_APP_API_URI}/api/admin/years`)
      .then(res => {
        const years: ApplicationYear[] =
          res.data &&
          res.data.sort((a, b) =>
            a.year > b.year ? -1 : b.year > a.year ? 1 : 0
          );
        this.years = years;

        const now = new Date();

        let selectedYear = years.find(year => {
          const startDate = new Date(year.startDate);
          const endDate = new Date(year.endDate);

          return now > startDate && now < endDate;
        });

        if (!selectedYear) {
          selectedYear = years && years[0];
        }

        this.selectedYear = (selectedYear && selectedYear.year) || 'ALL';
        this.filterYear(this.selectedYear);
      })
      .catch(e => {
        Vue.toasted.error('Unable to fetch application years');
        console.error(e);
      });
  },
  beforeMount() {
    this.columnDefs = [
      {
        headerCheckboxSelection: true,
        checkboxSelection: true,
        width: 96,
        resizable: false,
      },
      {
        field: 'applicationDateCreated',
        headerName: 'Submission Date',
        cellRendererFramework: DateCellRenderer,
        sort: 'desc',
        comparator: (date1, date2) => {
          const a = new Date(date1);
          const b = new Date(date2);

          if (a > b) {
            return 1;
          } else if (b > a) {
            return -1;
          } else {
            return 0;
          }
        },
      },
      {
        field: 'lastName',
      },
      {
        field: 'firstName',
      },
      {
        field: 'email',
        width: 300,
        cellRendererFramework: EmailCellRenderer,
      },
      {
        headerName: 'Local',
        field: '',
        valueGetter: params => {
          return params.data.local || params.data.applicationLocal;
        },
      },
      {
        headerName: 'Region',
        field: '_region',
        valueGetter: params => {
          return params.data.region || params.data.applicationRegion;
        },
      },
      {
        headerName: 'AltRegion',
        field: '_altRegion',
        valueGetter: params => {
          return params.data.altRegion || params.data.applicationAltRegion;
        },
      },
      {
        field: 'cellPhone',
        valueGetter: params => {
          const phone = params.data.cellPhone;
          return Utils.formatPhoneNumber(phone);
        },
      },
      {
        field: 'homePhone',
        valueGetter: params => {
          const phone = params.data.homePhone;
          return Utils.formatPhoneNumber(phone);
        },
      },
      {
        headerName: 'GPA',
        field: 'gpa',
        editable: true,
        onCellValueChanged: this.updateGpa,
        valueGetter: params => {
          return params.data.gpa || '';
        },
      },
      {
        field: 'score',
      },
      {
        cellRendererFramework: DownloadApplicationRenderer,
        width: 300,
      },
      {
        headerName: 'Part B',
        field: 'partBUri',
        cellRendererFramework: PartBCellRenderer,
        width: 300,
      },
    ];
  },
  name: 'Admin',
  watch: {
    fetchingData(isLoading: boolean) {
      if (!this.gridApi) {
        return;
      }
      if (isLoading) {
        this.gridApi.showLoadingOverlay();
      } else {
        this.gridApi.hideOverlay();
      }
    },
  },
});
